export default {
      id: "ic-up-icon-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic-up-icon-usage",
      toString: function () {
        return this.url;
      }
    }